// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import { sync } from 'vuex-router-sync';
import LocalizedLabel from '@/components/LocalizedLabel';
import { gatewayApi } from '@/api';
import { gatewayMock } from '@/mocks';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(LocalizedLabel);

Vue.use(Vuetify, {
  theme: {
    primary: '#2e3743',
    secondary: '#009aff',
  },
});

sync(store, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

if (process.env.NODE_ENV === 'development') {
  gatewayMock.initMasterMock();
}

gatewayApi.init();
